import { useQuery } from "react-query";
import { getRouteDayOverview } from "../api/dailyOverview";
import { useUserSession } from "../context/UserContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { queryKeys } from "../data/queryKeys";

export const useRouteDayOverview = (date: string) => {
  const { userSession } = useUserSession();
  const { activeWorkspace } = useWorkspace();
  const token = userSession?.token?.accessToken;
  const workspaceId = activeWorkspace?.workspaceId ?? "";

  return useQuery(
    queryKeys.routeDayOverview(workspaceId, date),
    () => getRouteDayOverview(token!, workspaceId, date),
    {
      enabled: Boolean(token && workspaceId && date),
      keepPreviousData: false,
      staleTime: 30_000,
      // Returning from the existing Planner/optimizer must reload its saved
      // sequence, even when the previous overview is still within staleTime.
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
    },
  );
};
